<script setup lang="ts">
    import { useI18n } from 'vue-i18n'
    import type { AgentPublic } from 'models'
    import PkAvatar from './PkAvatar.vue'

    defineProps<{
        agents: AgentPublic[]
    }>()

    const modelValue = defineModel<string | undefined>({ default: undefined })

    const { t: $t } = useI18n({ useScope: 'global' })
</script>

<template>
    <VvCombobox
        v-model="modelValue"
        :options="agents"
        value-key="id"
        label-key="name"
        name="agentId"
        select-hint-label=""
        deselect-hint-label=""
        selected-hint-label=""
        :placeholder="$t('placeholder.selectAgent')"
        :unselectable="false"
        :disabled="agents.length < 2"
        modifiers="compact surface"
        dropdown-modifiers="menu mobile"
        offset="2">
        <template #option="{ option }">
            <span class="flex items-center gap-xs min-w-0">
                <PkAvatar
                    modifiers="surface ring"
                    :img-src="(option as AgentPublic).interface?.logo"
                    :name="(option as AgentPublic).name" />
                <span class="truncate">
                    {{ (option as AgentPublic).name }}
                </span>
            </span>
        </template>
        <template #value="{ selectedOptions }">
            <span
                v-if="selectedOptions.length"
                class="flex items-center gap-xs min-w-0">
                <PkAvatar
                    modifiers="surface ring"
                    :img-src="
                        (selectedOptions[0] as AgentPublic).interface?.logo
                    "
                    :name="(selectedOptions[0] as AgentPublic).name" />
                <span class="text-word truncate">
                    {{ (selectedOptions[0] as AgentPublic).name }}
                </span>
            </span>
        </template>
    </VvCombobox>
</template>
